import { FC, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import PrinterMonthlySummary from './components/printer-monthly-summary'

const PrinterContent: FC = () => {
    const [month, setMonth] = useState<Dayjs>(() => dayjs())

    return <PrinterMonthlySummary month={month} onMonthChange={setMonth} />
}

export default PrinterContent
